import { useEffect, useCallback } from 'react';

export const usePostMessageListener = <Payload extends {}>(
  callback: (event: MessageEvent<Payload>) => void,
  dependencies: Array<any>,
) => {
  const callbackMemo = useCallback(callback, dependencies);

  useEffect(() => {
    window.addEventListener('message', callback);
    return () => {
      window.removeEventListener('message', callback);
    };
  }, [callbackMemo]);
};
